import React, { useState, useEffect, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    Box,
    Typography,
    TextField,
    Button,
    Tabs,
    Tab,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    MenuItem,
    Stack,
    Grid,
    CircularProgress,
    InputAdornment,
    Autocomplete
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { makeApiRequest } from '../../../utils/api';
import { formatDate } from '../../../helpers/timeHelper';
import { getLocation } from '../../../helpers/commonHelper';
import Nodata from '../../../assets/nodata.png';
import { Search } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const StyledPaper = ({ children, title }) => (
    <Paper
        sx={{
            px: 3,
            py: 5,
            // mt: 3,
            backgroundColor: 'white',
            borderRadius: 1,
            position: 'relative'
        }}
    >
        {title && (
            <Typography
                sx={{
                    position: 'absolute',
                    top: '-12px',
                    left: '20px',
                    backgroundColor: 'white',
                    px: 1,
                    color: 'text.secondary'
                }}
            >
                {title}
            </Typography>
        )}
        {children}
    </Paper>
);

const StyledTextField = ({ ...props }) => (
    <TextField
        {...props}
        size='small'
        sx={{
            '& .MuiOutlinedInput-root': {
                backgroundColor: 'white'
            },
            width: "100%",
            ...props.sx
        }}
    />
);


const ProjectAssignment = () => {
    const navigate = useNavigate();
    const control = localStorage.getItem('control');
    const userLocation = localStorage.getItem('userLocation');
    const [currentTab, setCurrentTab] = useState(0);
    const [filters, setFilters] = useState({
        batch: '',
        batch_name: '',
        course: '',
        course_name: '',
        program_date: '',
        Program: '',
        chapter: '',
        chapter_name: ''
    });
    const [tableData, setTableData] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [formData, setFormData] = useState({
        projectTitle: '',
        fileLocation: '',
        projectDescription: ''
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [courseList, setCourseList] = useState([]);
    const [modules, setModules] = useState([]);
    const [file, setFile] = useState([]);
    const [chapter, setChapter] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [flag, setFlag] = useState(false);
    const token = localStorage.getItem('authToken');
    const todayDate = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });

    const [month, day, year] = todayDate.split('/');
    const formattedDate = `${year}-${month}-${day}`;
    var today_date = formattedDate;

    // Set focus to project title on first render
    useEffect(() => {
        const projectTitleInput = document.querySelector('input[name="projectTitle"]');
        if (projectTitleInput) {
            projectTitleInput.focus();
        }
    }, []);

    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    };


    const handleChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value
        });
    };

    const handleSelectAll = (event) => {
        const isChecked = event.target.checked;
        setSelectAll(isChecked);

        const updatedData = tableData.map(row => ({
            ...row,
            selected: isChecked
        }));

        setTableData(updatedData);
        setSelectedStudents(isChecked ? updatedData.map(row => row.id) : []);
    };




    const handleRowSelect = (id) => {
        const updatedData = tableData.map(row => {
            if (row.id === id) {
                return { ...row, selected: !row.selected };
            }
            return row;
        });

        setTableData(updatedData);
        setSelectedStudents(updatedData.filter(row => row.selected).map(row => row.id));
        setSelectAll(updatedData.every(row => row.selected));
    };



    const handleFilterChange = (event) => {
        const { name, value } = event.target;

        if (name === "batch") {
            const selectedBatch = batchList.find(batch => batch.id === value);
            setFilters({
                ...filters,
                batch: value,
                batch_name: selectedBatch ? selectedBatch.batch_name : ''
            });
        }
        else if (name === "course") {
            const selectedCourse = courseList.find(course => course.id === value);
            setFilters({
                ...filters,
                course: value,
                course_name: selectedCourse ? selectedCourse.course_name : ''
            });
        }
        else if (name === "module") {
            const selectedModule = modules.find(module => module.module_id === value);
            setFilters({
                ...filters,
                module: value,
                module_name: selectedModule ? selectedModule.module : ''
            });
        }
        else if (name === "chapter") {
            const selectedChapter = chapter.find(chap => chap.chapter_id === value);
            setFilters({
                ...filters,
                chapter: value,
                chapter_name: selectedChapter ? selectedChapter.name : ''
            });
        }
        else {
            setFilters({
                ...filters,
                [name]: value
            });
        }
    };

    const fetchStudentData = async () => {
        setError(null);
        setFlag(true);
        try {
            const response = await makeApiRequest('post', '/api/student/list', {
                token: localStorage.getItem('authToken'),
            });

            const filteredData = response.data.filter(student =>
                (filters.batch ? student.batch_id === filters.batch : true) &&
                (filters.course ? student.course_id === filters.course : true) &&
                ((control == 2 || control == 4) && userLocation ? Number(student.location) === Number(userLocation) : true)
            );

            setTableData(filteredData);

        } catch (err) {
            console.error("Error fetching batches:", err);
            setError(err.message || 'Error fetching data');
        }
    };


    const fetchCourseData = async () => {
        setError(null);
        try {
            const response = await makeApiRequest('post', '/api/course/list', {
                token: localStorage.getItem('authToken'),
            });
            if (!response || response.status !== 'success' || !response.data) {
                throw new Error(response?.message || 'Invalid response from API');
            }
            setCourseList(response.data);
        }
        catch (err) {
            console.error("Error fetching batches:", err);
            setError(err.message || 'Error fetching data');
            setCourseList([]);
        } finally {
            setLoading(false);
        }
    }


    const fetchBatchData = async () => {
        setError(null);
        if (batchList.length > 0) return;
        setError(null);
        try {
            const response = await makeApiRequest('post', '/api/listBatches/active', {
                token: localStorage.getItem('authToken'),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            });

            if (!response || response.status !== 'success' || !response.data) {
                throw new Error(response?.message || 'Invalid response from API');
            }

            let responseData = response.data;
            if ((control == 2 || control == 4) && userLocation) {
                responseData = responseData.filter(
                    batch => Number(batch.location) === Number(userLocation)
                );
            }

            setBatchList(responseData);
        } catch (err) {
            console.error("Error fetching batches:", err);
            setError(err.message || 'Error fetching data');
            setBatchList([]);
        } finally {
            setLoading(false);
        }
    };
    const fetchChapterData = async () => {
        try {
            const response = await makeApiRequest('post', '/api/chapter/listbyModule', {
                token: localStorage.getItem('authToken'),
                id: filters.module
            });
            if (response.status === 'success' && response.data) {
                setChapter(response.data);

            }

        }
        catch (error) {
            console.error("Error fetching chapter:", error);
            toast.error("Failed to load chapters.");
        }
    };
    const fetchModuleData = async () => {
        setError(null);
        try {
            const response = await makeApiRequest('post', '/api/module/list', {
                token: localStorage.getItem('authToken'),
                per_page: 100
            });

            if (response.status === 'success' && response.data) {
                setModules(response.data.data);
            } else {
                throw new Error("Failed to fetch modules");

            }
        } catch (error) {
            console.error("Error fetching modules:", error);
            toast.error("Failed to load modules.");
        }
    };

    useEffect(() => {
        fetchCourseData();
        fetchBatchData();
        fetchModuleData();
    }, []);
    
    useEffect(() => {
        if (filters.module) {
            fetchChapterData();
        }
    }, [filters.module]);
    

    const handleSubmit = async () => {
        if (!formData.projectTitle || !formData.projectDescription || !filters.batch || !filters.course) {
            toast.warn('Please Fill All Required Fields.');
            return;
        }

        const selectedStudents = tableData.filter(student => student.selected);

        if (selectedStudents.length === 0) {
            toast.warn('Please select at least one student.');
            return;
        }

        const assignmentData = selectedStudents.map(student => ({
            project_title: formData.projectTitle,
            project_description: formData.projectDescription,
            due_date: today_date,
            stud_id: student.userid,
            stud_name: student.name,
            source_file_path: formData.fileLocation,
            created_by: localStorage.getItem('username'),
            batch_id: filters.batch,
            batch_name: filters.batch_name,
            course_id: filters.course,
            course_name: filters.course_name,
            program_id: filters.module,
            module_name: filters.module_name,
            chapter_id: filters.chapter,
            chapter_name: filters.chapter_name
        }));

        const assignmentPayload = {
            token: localStorage.getItem('authToken'),
            data: assignmentData
        };

        setLoading(true);

        try {
            const response = await makeApiRequest('post', '/api/assignments/create', assignmentPayload);

            if (response && response.status === 'success') {
                toast.success('Assignment Created Successfully!');
                setFormData({ projectTitle: '', fileLocation: '', projectDescription: '' });
                navigate('/Assignment');
            } else {
                toast.error('Error creating assignment: ' + (response.message || 'Unknown error'));
            }
        } catch (err) {
            console.error('Error creating assignment:', err);
            toast.error('An error occurred while creating the assignment.');
        }
    };


    const filteredStudents = tableData.filter(student =>
        student.name.toLowerCase().includes(searchText.toLowerCase()) ||
        student.userid.toLowerCase().includes(searchText.toLowerCase())
    );

    if (loading) return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="400px"
        >
            <CircularProgress
                size={40}
                thickness={4}
                sx={{
                    color: '#481E82',
                }}
            />
        </Box>
    );



    return (

        <div style={{ maxWidth: '100%', margin: 'auto', padding: '24px', backgroundColor: "#F1F4F9", fontFamily: "Roboto", minHeight: "100vh" }}>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            {/* Header */}
            <Box sx={{ height: "50px", display: "flex", alignItems: "center", backgroundColor: "" }}>
                <Typography variant='h4' sx={{ color: "#481E82", fontWeight: "500", fontSize: { xs: '24px', sm: '34px' } }}> Create Project Assignment</Typography>
            </Box>

            {currentTab === 0 && (
                <>
                    <StyledPaper>
                        <Grid container>
                            <Grid item xs={12}>
                                <Box sx={{
                                    width: "100%", height: "auto", borderRadius: "12px", border: 2, borderColor: "grey", py: 2, borderColor: "rgba(128, 128, 128, 0.3)", px: 3, boxSizing: "border-box"
                                }}>
                                    <Typography color="#481E82" gutterBottom sx={{ fontSize: '20px', marginBottom: '20px' }}>
                                        <strong style={{ fontWeight: 500 }}>Search & Assign to Students</strong>
                                    </Typography>
                                    <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                                        <Grid item xs={12}>
                                            {/* <Stack direction="row" spacing={8}> */}
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={4} lg={3.6}>

                                                    <Autocomplete
                                                        size="small"
                                                        fullWidth
                                                        options={batchList} // Provide batch list as options
                                                        getOptionLabel={(option) => option.batch_name} // Display batch name
                                                        value={batchList.find((b) => b.id === filters.batch) || null} // Ensure selected batch is shown
                                                        onOpen={fetchBatchData} // Fetch batch data when dropdown opens
                                                        onChange={(event, newValue) => handleFilterChange({ target: { name: "batch", value: newValue ? newValue.id : "" } })} // Handle selection
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Batch"
                                                                name="batch"
                                                                autoFocus
                                                                required
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    '& .MuiFormLabel-asterisk': {
                                                                        color: 'red',
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />



                                                </Grid>
                                                <Grid item xs={12} sm={4} lg={3.6}>

                                                    <Autocomplete
                                                        size="small"
                                                        fullWidth
                                                        options={courseList} // Provide course list as options
                                                        getOptionLabel={(option) => option.course_name} // Display course name
                                                        value={courseList.find((c) => c.id === filters.course) || null} // Ensure selected course is shown
                                                        onOpen={fetchCourseData} // Fetch course data when dropdown opens
                                                        onChange={(event, newValue) =>
                                                            handleFilterChange({ target: { name: "course", value: newValue ? newValue.id : "" } })
                                                        } // Handle selection
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Course"
                                                                name="course"
                                                                placeholder="Select course"
                                                                required
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    '& .MuiFormLabel-asterisk': {
                                                                        color: 'red',
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />

                                                </Grid>
                                                <Grid item xs={12} sm={4} lg={3.6}>
                                                    <TextField
                                                        placeholder="Student name or ID"
                                                        variant="outlined"
                                                        size="small"
                                                        value={searchText}
                                                        onChange={(e) => setSearchText(e.target.value)}
                                                        sx={{
                                                            width: "100%",
                                                            backgroundColor: 'white'
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <Search />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />

                                                </Grid>
                                                <Grid item xs={12} sm={12} lg={1.2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={fetchStudentData}
                                                        sx={{
                                                            // height: '56px',
                                                            width: { xs: 'fit-content', lg: "100%" }
                                                        }}
                                                    >
                                                        Search
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            {/* </Stack> */}
                                        </Grid>

                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>

                        {(flag) && (



                            <Grid container spacing={2} mt={2} sx={{ display: "flex", justifyContent: "space-between", }} >
                                <Grid item xs={12} sm={5} md={4} /* pt={'0!important'} */ >
                                    {/* Table Section */}
                                    <Paper sx={{ borderRadius: "12px 12px 0 0" }}>
                                        <TableContainer sx={{ borderRadius: "12px 12px 0 0" }}>
                                            <Table size='medium' padding='none'>
                                                <TableHead>
                                                    <TableRow sx={{ backgroundColor: '#CAF0F8' }}>
                                                        <TableCell align="left" sx={{ display: "flex", alignItems: "center" }}>
                                                            <Checkbox
                                                                checked={selectAll}
                                                                onChange={handleSelectAll}
                                                            />

                                                            <strong>Select All</strong>
                                                        </TableCell>
                                                        <TableCell><strong>Student Name</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {filteredStudents.map((row) => (
                                                        <TableRow key={row.id}>
                                                            <TableCell align="left">
                                                                <Checkbox
                                                                    checked={row.selected || false} // Ensure boolean value
                                                                    onChange={() => handleRowSelect(row.id)}
                                                                />
                                                            </TableCell>
                                                            <TableCell>{row.name}<br />
                                                                <Typography variant="body2" sx={{ fontSize: '13px', color: 'gray' }}>
                                                                    {row.userid} | {getLocation(row.location)}
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}

                                                    {(filteredStudents.length <= 0) && (
                                                        <TableRow >
                                                            <TableCell colSpan={2} sx={{ height: "375px" }}>
                                                                <Box
                                                                    component="img"
                                                                    src={Nodata}
                                                                    // alt="Project content"
                                                                    sx={{
                                                                        width: "80%",
                                                                        height: "100%",
                                                                        objectFit: "contain"
                                                                    }}
                                                                />

                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>

                                            </Table>
                                        </TableContainer>

                                    </Paper>
                                </Grid>


                                <Grid item xs={12} sm={7} md={8} >
                                    <Paper elevation={1} sx={{
                                        backgroundColor: "#F1F4F9", padding: 3, borderRadius: "12px 12px 0 0"
                                        ,
                                    }}>
                                        <Typography color="#481E82" gutterBottom sx={{ fontSize: '20px', marginBottom: '20px' }}>
                                            <strong style={{ fontWeight: 500 }}>Enter assignment details</strong>
                                        </Typography>
                                        <Grid container spacing={4} alignItems="stretch"  >
                                            <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, flexGrow: 1 }}>
                                                    <Autocomplete
                                                        size="small"
                                                        fullWidth
                                                        required
                                                        sx={{
                                                            '& .MuiFormLabel-asterisk': {
                                                                color: 'red',
                                                            },
                                                        }}
                                                        options={modules} // List of modules
                                                        getOptionLabel={(option) => option.module || ""} // Ensure valid label
                                                        value={modules.find((m) => m.module_id === filters.module) || null} // Ensure selected module is shown
                                                        onOpen={fetchModuleData} // Fetch modules when dropdown opens
                                                        onChange={(event, newValue) => handleFilterChange({ target: { name: "module", value: newValue ? newValue.module_id : "" } })}
                                                        renderInput={(params) => (
                                                            <StyledTextField {...params} label="Module" placeholder="Select Module" InputLabelProps={{ shrink: true }} />
                                                        )}
                                                    />



                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, flexGrow: 1 }}>
                                                    <Autocomplete
                                                        size="small"
                                                        fullWidth
                                                        required
                                                        sx={{
                                                            '& .MuiFormLabel-asterisk': {
                                                                color: 'red',
                                                            },
                                                        }}
                                                        options={chapter} // List of chapters
                                                        getOptionLabel={(option) => option.name || ""} // Display chapter name
                                                        value={chapter.find((c) => c.chapter_id === filters.chapter) || null} // Ensure selected chapter is shown
                                                        onOpen={fetchChapterData} // Fetch chapters when dropdown opens
                                                        onChange={(event, newValue) => handleFilterChange({ target: { name: "chapter", value: newValue ? newValue.chapter_id : "" } })}
                                                        renderInput={(params) => (
                                                            <StyledTextField {...params} label="Chapter" placeholder="Select Chapter" InputLabelProps={{ shrink: true }} />
                                                        )}
                                                    />

                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, flexGrow: 1 }}>

                                                    <StyledTextField
                                                        fullWidth
                                                        label="Project Title"
                                                        name="projectTitle"
                                                        value={formData.projectTitle}
                                                        onChange={handleChange}
                                                        InputLabelProps={{ shrink: true }}
                                                        required
                                                        placeholder="Enter project title"
                                                        size="small"
                                                        variant="outlined"
                                                        sx={{
                                                            width: "100%",
                                                            '& .MuiFormLabel-asterisk': {
                                                                color: 'red',
                                                            },
                                                        }}
                                                        autoFocus
                                                        inputProps={{ maxLength: 40 }}
                                                        // helperText={`${formData.projectTitle.length || 0}/40`}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    {`${formData.projectTitle?.length || 0}/40`}
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />

                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, flexGrow: 1 }}>

                                                    <StyledTextField
                                                        fullWidth
                                                        required
                                                        label="Input File Location"
                                                        name="fileLocation"
                                                        value={formData.fileLocation}
                                                        onChange={handleChange}
                                                        placeholder="Enter file location"
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{
                                                            '& .MuiFormLabel-asterisk': {
                                                                color: 'red',
                                                            },
                                                        }}

                                                    />
                                                    {/* <Box sx={{ flexGrow: 1 }} /> */}
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column'/*  mt: { xs: -2, md: 0 }, mb: { xs: 3, md: 0 }  */ }}>

                                                <StyledTextField
                                                    id="outlined-multiline-static"
                                                    label="Project Description"
                                                    fullWidth
                                                    multiline
                                                    required
                                                    rows={4}
                                                    value={formData.projectDescription}
                                                    onChange={handleChange}
                                                    name="projectDescription"
                                                    sx={{
                                                        '& .MuiFormLabel-asterisk': {
                                                            color: 'red',
                                                        },
                                                    }}
                                                    placeholder="Enter project description"
                                                    variant="outlined"
                                                    // defaultValue="Default Value"
                                                    InputLabelProps={{ shrink: true }}

                                                />

                                                {/* </Box> */}
                                            </Grid>

                                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: "flex-end" }}>
                                                {/* <Box sx={{}}> */}
                                                <Button
                                                    variant="contained"
                                                    onClick={handleSubmit}
                                                    sx={{
                                                        backgroundColor: '#1976d2',
                                                        color: 'white',
                                                        textTransform: 'uppercase',
                                                        px: 4,
                                                        py: 1,
                                                        // m: 4,
                                                        '&:hover': {
                                                            backgroundColor: '#1565c0'
                                                        }
                                                    }}
                                                >
                                                    CREATE ASSIGNMENT
                                                </Button>
                                                {/* </Box> */}
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                        )}

                    </StyledPaper>


                </>
            )
            }
            {
                currentTab === 1 && (
                    <Box sx={{ mt: 3, backgroundColor: 'white', p: 3, borderRadius: 1, minHeight: '300px' }}>
                    </Box>
                )
            }
        </div >
    );
};

export default ProjectAssignment;